<template>
  <img
    v-if="image"
    data-test="tab-image-img"
    class="tab-image"
    :src="image"
    :style="imgStyle"
    :alt="alt"
  >
  <font-awesome-icon
    v-else
    data-test="tab-image-font-awesome-icon"
    class="tab-image"
    :icon="icon"
    :fixed-width="fixedWidth"
    :style="faStyle"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import portfolioImg from '@/assets/imgs/Portfolio.png'
import { PATH_ROOT, PATH_SUBROOT } from '@/constants'

const props = {
  storyPath: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 0,
  },
  fixedWidth: Boolean,
  alt: {
    type: String,
    default: '',
  },
  secondaryAppIconId: {
    type: Number,
    default: null,
  },
}

@Component
export default class TabImage extends Vue.extend({ props }) {
  defaultWidth = '50px'

  get nodeImage () {
    return this.$typedStore.primary.entities.images.imageOrPreview(['node', ...this.storyPath.split('/'), 'icon'])
  }

  get image () {
    if (this.secondaryAppIconId) {
      return this.secondaryAppIcon
    } else if (this.storyPath === PATH_SUBROOT) {
      return this.nodeImage || portfolioImg
    } else {
      return this.nodeImage
    }
  }

  get icon () {
    if (this.storyPath === PATH_ROOT) {
      return this.nodeImage || ['fas', 'home']
    } else {
      return ['far', 'image']
    }
  }

  get secondaryAppIcon () {
    return this.$typedStore.primary.entities.images.secondaryAppIcon(this.secondaryAppIconId)
  }

  get imgStyle () {
    if (!this.size) {
      return {}
    }
    return this.fixedWidth ? {
      'max-height': this.size * 0.7 + 'px',
      'max-width': this.defaultWidth,
    } : {
      'max-width': this.size * 0.8 + 'px',
      'max-height': this.size * 0.4 + 'px',
      'vertical-align': 'middle',
    }
  }

  get faStyle () {
    if (!this.size) {
      return {}
    }
    return this.fixedWidth ? {
      height: this.size * 0.7 + 'px',
      width: this.defaultWidth,
    } : {
      ...this.imgStyle,
      width: this.size * 0.6 + 'px',
      height: 'auto',
    }
  }
}

</script>
